$(document).ready(function () {
  $('.x-hamburger').on('click', function() {
    var links = $('.x-main-menu-regular a');

    if (links.hasClass('animated-link')) {
      $('.x-main-menu-forms').addClass('hide');
      $('.x-main-menu-regular').removeClass('hide');
    }

    $('body').toggleClass('menu-noscroll mobile-menu--active');
    $(this).toggleClass('mobile-nav--layer open');
    $('.x-main-menu').toggleClass('menu-main--anim');

    links.toggleClass('animated-link');
  });

  $('a.x-header-authentication, .x-main-menu-authentication').on('click', function(event) {
    event.preventDefault();
    $('.x-main-menu-regular').addClass('hide');
    $('.x-main-menu-forms').removeClass('hide');
    $('.x-authentication-div').removeClass('hide');
    $('.x-registration-div').addClass('hide');

    if ($(this).hasClass('x-header-authentication')) {
      $('.x-hamburger').click();
      $('.x-ambassador-hamburger').click();
    }
  });

  $('a.x-header-registration, .x-main-menu-registration').on('click', function(event) {
    event.preventDefault();
    $('.x-main-menu-regular').addClass('hide');
    $('.x-main-menu-forms').removeClass('hide');
    $('.x-registration-div').removeClass('hide');
    $('.x-authentication-div').addClass('hide');

    if ($(this).hasClass('x-header-registration')) {
      $('.x-hamburger').click();
      $('.x-ambassador-hamburger').click();
    }
  });

  $('.x-logged-user-ico').on('click', function(e) {
    $(this).parent().siblings('.x-logged-user-tooltip').toggleClass('active');
    return false;
  });

  $('body').on('click', function(event) {
    var target        = $(event.target);
    var initial_click = target.parents('.x-logged-user-ico').length !== 0;
    var not_on_tooltip  = target.parents('.x-logged-user-tooltip').length === 0;

    if (!initial_click && not_on_tooltip) {
      $('.x-logged-user-tooltip').removeClass('active');
    }
  });

  function hideMainMenu() {
      var main_menu = document.querySelector('.menu-main');
      var links     = document.querySelectorAll('.nav-block a');
      var overlay   = document.querySelector('.overlay');

      $('.mobile-nav--switch').removeClass('open mobile-nav--layer');
      $(document.body).removeClass('menu-noscroll');
      $(links).removeClass('animated-link');
      $(main_menu).removeClass('menu-main--anim');
      $(overlay).removeClass('overlay--menu');
  }

  $('.x-base-overlay').click(hideMainMenu);

  $('.x-main-menu .x-dropdown-trigger').doubleTapToGo();
});
